module.exports = __webpack_public_path__ + "static/media/login-img.0622a48c.svg";